export function navigateToLogin(loginRoute: string, currentUrl: URL) {
  return navigateTo(`${loginRoute}?login_redirect=${currentUrl}`, { external: true })
}
